import React, { JSX } from 'react';
import { ApiGender, ApiTraveler } from '@ibe/api';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faChild,
  faFemale,
  faMale,
  faUser,
  IconDefinition
} from '@fortawesome/free-solid-svg-icons';
import fallback from '../../../../_Translations/generated/iso-items-base.en.t.json';
import Keys from '../../../../_Translations/generated/iso-items-base.en.t.json.keys';

import useTranslation from '../../../Hooks/useTranslation';
import getGroupedTravelers from '../getGroupedTravelers';

interface Props {
  traveler: ApiTraveler[];
}
const CheckoutListTraveler = (props: Props): JSX.Element => {
  const { t } = useTranslation('iso-items-base', fallback, Keys);

  const getIcon = (traveler: ApiTraveler): IconDefinition => {
    switch (traveler.gender) {
      case ApiGender.MALE:
        return faMale;
      case ApiGender.FEMALE:
        return faFemale;
      case ApiGender.INFANT:
        return faChild;
      default:
        return faUser;
    }
  };

  const { traveler: travelers } = props;

  return (
    <div>
      {getGroupedTravelers(travelers)
        .map(travelersByType =>
          travelersByType.map((traveler, index) => {
            return (
              <div key={traveler.id}>
                <Icon icon={getIcon(traveler)} className="mr-3" />
                {traveler.lastName && traveler.firstName
                  ? `${traveler.salutation ? traveler.salutation : ''} ${traveler.firstName} ${
                      traveler.lastName
                    }`
                  : `${t(traveler.type.toLowerCase())} ${index + 1}`}
              </div>
            );
          })
        )
        .flat()}
    </div>
  );
};

export default CheckoutListTraveler;
